import { Delete, FilterAlt } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { StyledGlStack, StyledGridIcons } from "styles/globals";
import TextFieldCm from "../TextField";
import { useForm } from "react-hook-form";
import { emptyKeyRemover } from "helper/emptyKeyRemover";

export default function FilterDataCm({
  inputs,
  getDataFn,
  setFilterData,
  setPage,
}) {
  const initialValues = inputs
    .map((item) => item.id)
    .reduce((obj, key) => {
      obj[key] = "";
      return obj;
    }, {});

  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm();

  const onFilter = async (values) => {
    const data = values;

    await setFilterData(values);
    setPage(1);
    getDataFn(true, false, data);
  };
  const onRemoveFilter = () => {
    setPage(1);
    reset(initialValues);
    setFilterData(initialValues);
    getDataFn(false, true);
  };
  return (
    <StyledGlStack>
      <Grid container>
        {inputs &&
          inputs.map((input) => (
            <Grid key={input.id} item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                {...input}
                selectItems={
                  input.selectFilterCondition
                    ? eval(input.selectFilterCondition)
                      ? input.selectItems
                      : []
                    : input.selectItems
                }
                // inpSize={"small"}
                shrink={
                  watch(`${input.id}`) && watch(`${input.id}`) !== ""
                    ? true
                    : false
                }
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
          ))}
      </Grid>
      <Grid container sx={{ direction: "rtl" }}>
        <StyledGridIcons item sm={2} xs={12} p={1}>
          <IconButton color="error" onClick={onRemoveFilter}>
            <Tooltip title="حذف فیلتر" placement="top">
              <Delete />
            </Tooltip>
          </IconButton>
          <IconButton color="primary" onClick={handleSubmit(onFilter)}>
            <Tooltip title="اعمال فیلتر" placement="top">
              <FilterAlt />
            </Tooltip>
          </IconButton>
        </StyledGridIcons>
      </Grid>
    </StyledGlStack>
  );
}
